export default "__VITE_ASSET__1GuVjIvC__"